module.exports = __webpack_public_path__ + "media/images/flags/1x1/cat-2be6f4aaca8c51e0955d96bfd2cedc64.svg";